import { LLMInstructionUpdateDto } from "../../dto/llm-instructions/lm-instruction-update.dto";
import { LLMInstructionBaseDto, LLMInstructionDto } from "../../dto/llm-instructions/lm-instruction.dto";
import { LLMInstruction, LLMInstructionBase } from "../../models/llm-instruction.model";

export class LLMInstructionMapper {
  public static toModel(dto: LLMInstructionDto): LLMInstruction {
    return {
      id: dto.id,
      code: dto.code,
      text: dto.text,
      sessionCategoryId: dto.session_category_id,
    }
  }

  public static toCreateDto(model: LLMInstructionBase): LLMInstructionBaseDto {
    return {
      code: model.code,
      text: model.text,
      session_category_id: model.sessionCategoryId ?? null,
    }
  }

  public static toUpdateDto(model: LLMInstruction): LLMInstructionUpdateDto {
    return {
      text: model.text,
    }
  }
}
